"use client";
import React, { useState, useRef } from "react";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

const Page = () => {
  const contentRef = useRef(null);

  const downloadPDF = async () => {
    if (!contentRef.current) return;

    try {
      const scale = 2;
      const canvas = await html2canvas(contentRef.current, {
        scale,
        useCORS: true,
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;

      let positionY = 0;

      while (positionY < canvasHeight) {
        const pageCanvas = document.createElement("canvas");
        pageCanvas.width = canvasWidth;
        pageCanvas.height = (pdfHeight * canvasWidth) / pdfWidth;

        const context = pageCanvas.getContext("2d");
        if (context) {
          context.drawImage(
            canvas,
            0,
            positionY,
            canvasWidth,
            pageCanvas.height,
            0,
            0,
            pageCanvas.width,
            pageCanvas.height,
          );
        }

        const pageData = pageCanvas.toDataURL("image/png");
        pdf.addImage(pageData, "PNG", 0, 0, pdfWidth, pdfHeight);
        positionY += pageCanvas.height;

        if (positionY < canvasHeight) {
          pdf.addPage();
        }
      }

      pdf.save("dieu-khoan-va-dich-vu.pdf");
    } catch (error) {
      console.error("Lỗi khi tải PDF:", error);
    }
  };

  return (
    <>
      <div>
        <div className={`py-8 md:py-[64px] lg:py-[80px] flex flex-col gap-6 md:gap-8 `}>
          <h1 className=" text-third text-center text-[24px] xs:text-[32px] lg:text-[48px] font-semibold">
            Điều khoản sử dụng
          </h1>
          <p className="text-secondary text-[18px] md:text-[20px] text-center">Có hiệu lực từ ngày 01/06/2024</p>

          <button onClick={downloadPDF} className={`btn-primary h-[56px] w-[177px] mx-auto`}>
            Tải xuống PDF
          </button>
        </div>

        <div ref={contentRef} className="md:w-[720px] mx-auto p-6">
          <div className="text-secondary mb-8 md:mb-12 text-justify">
            <p className="mb-4">
              Dành cho người đăng ký tại California: Bạn có thể hủy gói đăng ký của mình, mà không có hình phạt hoặc
              nghĩa vụ nào, vào bất kỳ lúc nào trước nửa đêm của ngày làm việc thứ ba kể từ ngày bạn đăng ký. Nếu bạn đã
              đăng ký bằng Dịch vụ Bên ngoài (ví dụ: Apple ID, Google Play), bạn phải hủy thông qua Dịch vụ Bên ngoài
              của bạn, như được nêu chi tiết hơn trong Mục 8a. Nếu bạn đã đăng ký thông qua ID Apple, việc hoàn tiền sẽ
              được Apple, chứ không phải Teklove, xử lý. Bạn có thể yêu cầu hoàn tiền từ Apple thông qua tài khoản Apple
              ID trên điện thoại của bạn hoặc tại https://getsupport.apple.com. Tất cả những người dùng khác có thể yêu
              cầu hoàn tiền bằng cách liên hệ với Dịch vụ Khách hàng của Teklove thông qua Trung tâm Trợ giúp của chúng
              tôi, hoặc bằng cách gửi email hoặc thông báo có chữ ký và ghi ngày tháng nêu rằng bạn, tức người mua, đang
              hủy bỏ thỏa thuận này hoặc các từ ngữ có hiệu lực tương tự khác. Ngoài ra, vui lòng nêu rõ tên và địa chỉ
              email, số điện thoại hoặc số nhận dạng duy nhất mà bạn đã sử dụng để đăng ký tài khoản của mình.
            </p>

            <p>
              Thông báo này sẽ được gửi tới: Teklove, Người nhận: Cancellations (Bộ phận Hủy dịch vụ), P.O. Box 25472,
              Dallas, Texas 75225, USA. Một phần hoạt động kinh doanh của Công ty được tiến hành tại 8750 N. Central
              Expressway, Suite 1400, Dallas, TX 75231. Bạn có thể nhận được Điều khoản Sử dụng này (&quot;Điều
              khoản&quot;) qua email bằng cách gửi thư tới Box 25472, Dallas, Texas 75225, USA. Theo Bộ luật Dân sự
              California §1789.3, bạn có thể báo cáo các khiếu nại lên Bộ phận Hỗ trợ Khiếu nại của Phòng Dịch vụ Người
              Tiêu dùng thuộc Bộ Sự vụ Người tiêu dùng California bằng cách liên hệ với họ qua văn bản tại Consumer
              Information Division, 1625 North Market Blvd., Suite N112 Sacramento, CA 95834, hoặc gọi điện thoại đến số
              (800) 952-5210.
            </p>
          </div>
          <div className="flex flex-col gap-6">
            <h2 className="text-third font-semibold text-[24px] md:text-[30px]">Giới thiệu</h2>

            <div className="flex flex-col gap-4 text-secondary">
              <p className="text-justify">
                Bằng cách truy cập hoặc sử dụng các Dịch vụ của Teklove, bạn đồng ý chịu ràng buộc bởi Thỏa thuận Điều
                khoản Sử dụng này (“Điều khoản” hoặc “Thỏa thuận”), bao gồm cả Chính sách Quyền riêng tư, Chính sách
                Cookie, Quy tắc Cộng đồng, và Lời khuyên về An toàn của chúng tôi, vì vậy điều quan trọng là bạn đọc
                Thỏa thuận này cũng như các chính sách và quy trình này trước khi bạn tạo tài khoản.
              </p>

              <p className="text-justify">
                VUI LÒNG XEM KỸ CÁC QUY ĐỊNH VỀ GIẢI QUYẾT TRANH CHẤP TẠI MỤC 15 DƯỚI ĐÂY. CÁC QUY ĐỊNH NÀY ĐIỀU CHỈNH
                CÁCH THỨC GIẢI QUYẾT TRANH CHẤP GIỮA BẠN VÀ TEKLOVE. CÁC QUY ĐỊNH NÀY BAO GỒM MỘT QUY TRÌNH GIẢI QUYẾT
                TRANH CHẤP KHÔNG CHÍNH THỨC BẮT BUỘC TRƯỚC THỦ TỤC TRỌNG TÀI (NGOẠI TRỪ CÁC KHIẾU NẠI RIÊNG LẺ VỀ TẤN
                CÔNG TÌNH DỤC HOẶC QUẤY RỐI TÌNH DỤC XẢY RA LIÊN QUAN ĐẾN VIỆC BẠN SỬ DỤNG CÁC DỊCH VỤ), THỎA THUẬN
                TRỌNG TÀI, LỰA CHỌN HÀNH ĐỘNG CỦA TÒA TIỂU TỤNG, TỪ CHỐI CỦA TÒA ÁN ĐỐI VỚI VỤ KIỆN TẬP THỂ, THỦ TỤC BỔ
                SUNG ĐỐI VỚI VIỆC NỘP HỒ SƠ TRỌNG TÀI CHO VỤ KIỆN TẬP THỂ, VÀ TỪ CHỐI XÉT XỬ CỦA BỒI THẨM ĐOÀN ẢNH HƯỞNG
                ĐẾN CÁC QUYỀN CỦA BẠN. TRONG PHÂN XỬ TRỌNG TÀI, THƯỜNG CÓ ÍT PHÁT HIỆN VÀ XEM XÉT PHÚC THẨM HƠN LÀ TẠI
                TÒA ÁN.
              </p>

              <p className="text-justify">
                Chúng tôi có thể cập nhật Điều khoản này vào từng thời điểm, vì vậy bạn hãy kiểm tra trang này thường
                xuyên để xem các cập nhật.
              </p>
            </div>

            <h2 className="text-third font-semibold text-[24px] md:text-[30px]">
              Tư cách hợp lệ tạo tài khoản; trách nhiệm của bạn
            </h2>

            <div className="flex flex-col gap-4 text-secondary">
              <p className="text-justify">
                Trước khi tạo tài khoản trên Teklove, hãy đảm bảo là bạn đủ điều kiện sử dụng các Dịch vụ của chúng tôi.
                Mục này cũng nêu chi tiết những gì bạn có thể làm và không thể làm khi sử dụng các Dịch vụ, cũng như các
                quyền bạn cấp cho Teklove.
              </p>

              <p className="text-justify">
                Bạn không được phép tạo tài khoản hoặc sử dụng các Dịch vụ trừ khi tất cả những điều sau đây là đúng, và
                bằng cách sử dụng các Dịch vụ của chúng tôi, bạn cam đoan và bảo đảm rằng:
              </p>

              <p className="text-justify">
                Bạn là một cá nhân (tức là không phải là một pháp nhân, công ty hợp danh hoặc tổ chức kinh doanh khác)
                ít nhất là 18 tuổi;
              </p>

              <p className="text-justify">Bạn đủ điều kiện hợp pháp để ký kết một hợp đồng ràng buộc với Teklove;</p>

              <p className="text-justify">
                Bạn không sống ở một quốc gia chịu lệnh cấm vận của Chính phủ Hoa Kỳ, hoặc bị Chính phủ Hoa Kỳ chỉ định
                là quốc gia &quot;hỗ trợ khủng bố&quot;;
              </p>

              <p className="text-justify">
                Bạn không có tên trong bất kỳ danh sách cá nhân nào bị cấm thực hiện hoạt động kinh doanh với Hoa Kỳ (ví
                dụ: danh sách Công dân bị Chỉ định Đặc biệt của Bộ Ngân khố Hoa Kỳ hoặc bất kỳ danh sách cơ quan chính
                phủ tương tự nào) và bạn cũng không phải đối mặt với bất kỳ lệnh cấm tương tự nào khác&#41;;
              </p>

              <p className="text-justify">Bạn không bị pháp luật nghiêm cấm sử dụng các Dịch vụ của chúng tôi;</p>

              <p className="text-justify">
                Bạn chưa phạm tội, chưa bị kết án hoặc cam kết không phản đối trọng tội hoặc tội phạm có thể bị truy tố
                (hoặc tội phạm có mức độ nghiêm trọng tương tự), tội phạm tình dục hoặc bất kỳ tội phạm nào liên quan
                đến bạo lực hoặc đe dọa bạo lực, trừ khi bạn đã nhận được sự khoan hồng cho một tội không bạo lực và
                chúng tôi đã xác định rằng bạn không có khả năng gây ra mối đe dọa cho những người dùng khác đối với các
                Dịch vụ của chúng tôi;
              </p>

              <p className="text-justify">
                Bạn không bắt buộc phải đăng ký là người phạm tội tình dục với bất kỳ cơ quan đăng ký tội phạm tình dục
                của tiểu bang, liên bang hoặc địa phương nào;
              </p>

              <p className="text-justify">Bạn không có nhiều hơn một tài khoản trên các Dịch vụ của chúng tôi;</p>

              <p className="text-justify">
                Trước đây bạn chưa bị chúng tôi hoặc các bên liên kết của chúng tôi xóa khỏi các Dịch vụ của chúng tôi
                hoặc các Dịch vụ của các bên liên kết của chúng tôi, trừ khi bạn có được sự cho phép rõ ràng bằng văn
                bản của chúng tôi để tạo một tài khoản mới.
              </p>

              <p className="text-justify">
                Nếu vào bất cứ thời điểm nào bạn thôi không còn đáp ứng các yêu cầu này, tất cả các quyền truy cập vào
                các Dịch vụ hoặc hệ thống của chúng tôi sẽ tự động bị thu hồi, và bạn phải xóa ngay tài khoản của mình,
                và chúng tôi có quyền gỡ bỏ quyền truy cập của bạn vào các Dịch vụ của chúng tôi mà không cần cảnh báo.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Page;
